// Custom SVG Icons for Accessibility features

// Accessibility Map Icon - Location pin with wheelchair symbol
export const AccessibilityMapIcon = ({ className = "w-6 h-6", color = "currentColor" }) => {
  // When color is white (used in homepage), we need the wheelchair to be in the contrasting color
  const isWhite = color === "white" || color === "#fff" || color === "#ffffff";
  const pinColor = color;
  const wheelchairColor = isWhite ? "#00599c" : color;
  
  return (
    <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Location pin */}
      <path 
        d="M12 0C7.31 0 3.5 3.81 3.5 8.5C3.5 14.88 12 24 12 24C12 24 20.5 14.88 20.5 8.5C20.5 3.81 16.69 0 12 0Z" 
        fill={pinColor}
      />
      {/* White circle background */}
      <circle cx="12" cy="8.5" r="6" fill={isWhite ? "white" : "white"}/>
      {/* Wheelchair head */}
      <circle cx="12.5" cy="5" r="1.3" fill={wheelchairColor}/>
      {/* Wheelchair body and arm */}
      <path 
        d="M11.5 6.5V9.5H14.5L16 13" 
        stroke={wheelchairColor} 
        strokeWidth="1.8" 
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Wheelchair wheel */}
      <circle cx="10.5" cy="11.5" r="2.8" stroke={wheelchairColor} strokeWidth="1.5" fill="none"/>
      {/* Small back wheel */}
      <circle cx="14" cy="12" r="0.8" fill={wheelchairColor}/>
    </svg>
  );
};

// WC Icon - Simple toilet/WC symbol for both accessible and ostomy toilets
export const WCIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* W letter */}
    <path 
      d="M3 6L5 18L8 10L11 18L13 6" 
      stroke={color} 
      strokeWidth="2.2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* C letter */}
    <path 
      d="M21 8C20 6.5 18.5 6 17 6C14.5 6 13 8 13 12C13 16 14.5 18 17 18C18.5 18 20 17.5 21 16" 
      stroke={color} 
      strokeWidth="2.2" 
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Aliases for backwards compatibility
export const AccessibleToiletIcon = WCIcon;
export const OstomyToiletIcon = WCIcon;
export const ToiletIcon = WCIcon;

// Ramp Icon for accessibility
export const RampIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Ramp slope */}
    <path 
      d="M2 20L22 8" 
      stroke={color} 
      strokeWidth="3" 
      strokeLinecap="round"
    />
    {/* Ground line */}
    <line x1="2" y1="20" x2="22" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    {/* Wheelchair on ramp */}
    <circle cx="10" cy="13" r="1" fill={color}/>
    <path d="M9 14v2h2l1 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    <circle cx="8" cy="17" r="1.5" stroke={color} strokeWidth="1" fill="none"/>
  </svg>
);

// Elevator Icon
export const ElevatorIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Elevator box */}
    <rect x="4" y="2" width="16" height="20" rx="1" stroke={color} strokeWidth="2" fill="none"/>
    {/* Door line */}
    <line x1="12" y1="4" x2="12" y2="20" stroke={color} strokeWidth="1"/>
    {/* Up arrow */}
    <path d="M8 9l-2 3h4l-2-3z" fill={color}/>
    {/* Down arrow */}
    <path d="M18 15l-2-3h4l-2 3z" fill={color}/>
    {/* Person inside */}
    <circle cx="9" cy="12" r="1" fill={color}/>
    <line x1="9" y1="13.5" x2="9" y2="17" stroke={color} strokeWidth="1"/>
    <line x1="7.5" y1="15" x2="10.5" y2="15" stroke={color} strokeWidth="0.8"/>
  </svg>
);

// Soccer Ball Icon
export const SoccerBallIcon = ({ className = "w-6 h-6", color = "currentColor", strokeWidth = 1.5 }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer circle */}
    <circle cx="12" cy="12" r="10" />
    {/* Pentagon pattern - classic soccer ball */}
    <polygon points="12,7 14.5,9 13.5,12 10.5,12 9.5,9" fill={color} />
    {/* Lines from pentagon to edges */}
    <line x1="12" y1="2" x2="12" y2="7" />
    <line x1="14.5" y1="9" x2="21" y2="6" />
    <line x1="13.5" y1="12" x2="20" y2="16" />
    <line x1="10.5" y1="12" x2="4" y2="16" />
    <line x1="9.5" y1="9" x2="3" y2="6" />
    {/* Bottom lines */}
    <line x1="12" y1="22" x2="12" y2="17" />
    <line x1="8" y1="17" x2="4" y2="20" />
    <line x1="16" y1="17" x2="20" y2="20" />
  </svg>
);
